<template>
  <div id="main" >
      <div class="infoimg" v-show="showinfo">
        <img class="img" src="../assets/info.png">
        <div class="infotip">{{info}}</div>
      </div>
      <ul v-show="showinfo==false">
          <li v-for="item in list" :key="item.department">
            <div class="infomainx">
                <div class="prenuminfo">
                    前方<span class="numx">{{item.prenum}}</span>位等候者
                </div>
                <div class="infodetail">
                    <mt-field label="当前排队科室"  v-model="item.department" readonly></mt-field>
                    <mt-field label="您的号码" v-model="item.serial" readonly></mt-field>
                    <mt-field label="预计距就诊时间" v-model="item.visittime" readonly></mt-field>
                </div>
                <mt-button type="danger" @click="cancelqueu(item.idnumber,item.keshi)" size="large">取消排队</mt-button>
            </div>
        </li>
    </ul> 
  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';
import { MessageBox } from 'mint-ui';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是提交预约页面',  
      showinfo:false,
      info:'',
      openid:'',   
      idnumber:'',   
      wxbaseinfo:{
        name:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      },
      list:[]
    }
  },
  created(){      
    // 1、从缓存读取openid    
    var temopenid= "oym4F6GbgItOvrqilutyj4W-y5Rw";//localStorage.getItem('wxopenid');
    if(temopenid && temopenid!='undefined'){
        // 缓存存在
        this.openid=temopenid;
        // 验证基本信息（是否有姓名）,无信息则完善基本信息
        this.checkInfo();   
    }
    else{
        // 缓存不存在，则跳转到授权页
        this.$router.push({path:'/authtest'});
    } 
  },
  methods:{
    // 验证用户信息
    checkInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 出错了，则跳到出错处理页面
                  this.$router.push({path:'/err'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    // this.$router.push({path:'/baseinfo'})
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{                    
                  // 信息完事，则正常显示 
                  this.idnumber=response.data.data.idnumber;
                  this.loadqueulist();
              }
            }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 加载系统提示信息
    loadqueulist(){
        var api='http://localhost:6334/api/getqueulist?idnumber=' + this.idnumber;
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 无记录
                // this.$router.push({path:'/err'});
                this.info=response.data.errmsg;
                this.showinfo=true;
            }
            else{
                // 解码用 
                this.showinfo=false;
                this.list=response.data.data                
            }
        }).catch((err)=>{
            alert('appointment获取系统信息失败：' + err);
        })
    },
    // 取消排队
    cancelqueu(cardno,deptcode){
      //alert 
      MessageBox.confirm("确定取消排队吗?").then(action => {
        // 确认取消排队
        var api='http://localhost:6334/api/cancelqueu';
        Axios.post(api,qs.stringify({
          'idnumber':cardno,
          'deptcode':deptcode
          }),{emulateJSON: true},{
            headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
          }).then(response=>{
              if(response.data.result=='false'){
                  // 取消排队失败
                  MessageBox.alert(response.data.errmsg).then(action => {
                  });
              }
              else{                
                  // 取消成功，则刷新列表
                  this.loadqueulist();
              }
        }),function(err){
            alert('appointment验证用户失败：' + err);
        }
        });      
    }
    
  }
}
</script>

<style>
#main,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
.numx{
    width: 64px;
    height: 64px;
    padding:0px 8px;
    border-radius:50%;
    background-color: royalblue;
    font-size: 64px;
    color:white;
    text-align: center;
}
.infomainx{
  width: 75%;
  height: 240px;
  background-color:white;
  font-family: Arial; 
  border: 1px solid #f4f4f4; 
  border-radius: 10px; 
  padding: 30px 30px; 
  margin: 5%;
}
.infodetail{
    top: 50px;
}
.prenuminfo{
    height: 64px;
    font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/queulist.vue